import { styled } from 'twin.macro';

const MarkdownEmpahsis = styled.em``;

export default MarkdownEmpahsis;
